import styled from 'styled-components';

import StyledButtonBrand from '../ui/Button/ButtonBrand.style';

export default styled(StyledButtonBrand)`
  flex: 1;
  border: 2px solid white;
`;
